import { render, staticRenderFns } from "./ConferenciaListConcluidas.vue?vue&type=template&id=6cdb81de"
import script from "./ConferenciaListConcluidas.vue?vue&type=script&lang=js"
export * from "./ConferenciaListConcluidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports